var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FiltersTemplate',{attrs:{"inputFilters":_vm.inputFilters,"adminFilters":_vm.adminFilters,"apiSlug":"follower"}}),_c('AlertExpirePassword'),_c('StatsPage',{staticClass:"kt-container mt-5",attrs:{"APIslug":'follower',"tabsData":_vm.tabsData,"displayChart":false,"inputFilters":_vm.inputFilters,"adminFilters":_vm.adminFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }